import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6653b056"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users-display-container" }
const _hoisted_2 = {
  key: 0,
  class: "no-user flex items-center"
}
const _hoisted_3 = { class: "information-text text-2xl" }
const _hoisted_4 = { class: "user-avatar-container" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["onClick", "title"]
const _hoisted_7 = { class: "user-tooltip" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tooltip-arrow" }, null, -1))
const _hoisted_9 = { class: "tooltip-text" }
const _hoisted_10 = {
  key: 0,
  class: "user-name"
}
const _hoisted_11 = {
  key: 1,
  class: "add-button-container"
}

import type { fetchedUser } from "@/types/fetchedUser"
import { ref, computed } from 'vue'
import UserPicker from '@/components/reusable/userPicker.vue'
import DefaultProfileImageDisplayer from '@/components/reusable/defaultProfileImageDisplayer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'userDisplay',
  props: {
    users: {},
    showAddButton: { type: Boolean },
    addButtonText: {},
    emptyStateText: {},
    allowRemove: { type: Boolean },
    showUserNames: { type: Boolean },
    imageSize: {}
  },
  emits: ["userRemoved", "userAdded", "addClicked"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emits = __emit

const isAddingUser = ref<boolean>(false)

function removeUser(user: fetchedUser) {
    emits('userRemoved', user)
}

function startUserAdd() {
    isAddingUser.value = true
    emits('addClicked')
}

function handleUserSelected(user: fetchedUser) {
    isAddingUser.value = false
    emits('userAdded', user)
}

function handlePickerCancelled() {
    isAddingUser.value = false
}

const imageClass = computed(() => {
    switch (props.imageSize) {
        case 'small': return 'rounded-image-small'
        case 'smaller': return 'rounded-image-smaller'
        case 'mini': return 'rounded-image-mini'
        default: return 'rounded-image-smaller'
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.users.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.emptyStateText || "No users assigned."), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
      return (_openBlock(), _createElementBlock("div", {
        key: user.id || user.emailAddress,
        class: "user-item"
      }, [
        _createElementVNode("div", _hoisted_4, [
          (user.profileImage)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: _normalizeClass([imageClass.value, "shadowed-image"]),
                src: user.profileImage,
                referrerpolicy: "no-referrer",
                alt: user.userName
              }, null, 10, _hoisted_5))
            : (_openBlock(), _createBlock(DefaultProfileImageDisplayer, {
                key: 1,
                width: "4rem",
                firstCharacter: user.userName?.charAt(0) || 'U'
              }, null, 8, ["firstCharacter"])),
          (_ctx.allowRemove)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: ($event: any) => (removeUser(user)),
                class: "user-remove",
                type: "button",
                title: `Remove ${user.userName}`
              }, " × ", 8, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(user.userName), 1)
          ])
        ]),
        (_ctx.showUserNames)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(user.userName), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.showAddButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: startUserAdd,
            class: "ac-minimal-button"
          }, _toDisplayString(_ctx.addButtonText || "Add"), 1),
          _renderSlot(_ctx.$slots, "user-picker", {
            isAdding: isAddingUser.value,
            onUserSelected: handleUserSelected,
            onCancelled: handlePickerCancelled
          }, () => [
            _createVNode(_Transition, {
              appear: "",
              type: "animation",
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (isAddingUser.value)
                  ? (_openBlock(), _createBlock(UserPicker, {
                      key: 0,
                      onUserSelected: handleUserSelected,
                      onCancelled: handlePickerCancelled
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})